import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertUserSendingDisabledStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UserSendingDisabled) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendUserSendingDisabled);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({ message: 'Отправка сообщений для вашего аккаунта недоступна' }));

      const error = new GuardError({
        message: 'Не удалось отправить первое сообщение: отправитель заблокирован администратором',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
